import React from "react"
import styled from "styled-components"

interface ArticleProps {
  articlephoto: string
  articletitle: string
  readingtime: string
  previewtext: string
  username: string
  releasedate: string
}

const ArticleUserDetails = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin-top: 20px;
  gap: 10px;
  @media (max-width: 460px) {
    margin-top: 16px;
  }
`
const ReadTime = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  gap: 6px;
  img {
    width: 17px;
    height: 17px;
  }
  .readtime-text {
    ${(props) => props.theme.typography.typographyMap}
    display: flex;
    align-items: center;
    color: ${(props) => props.theme.textDisabled};
    @media (max-width: 1023px) {
      font-size: 12px;
    }
  }
  @media (max-width: 1023px) {
    margin-top: 8px;
  }
`
const ArticleCardStyle = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  height: auto;
  width: 400px;
  padding: 20px;
  background: ${(props) => props.theme.cardColor};
  border-radius: 25px;
  &:hover {
    background-color: ${(props) => props.theme.hoverColor};
  }
  .cover-image {
    border-radius: 12px;
    object-fit: cover;
  }
  @media (max-width: 1023px) {
    width: 335px;
    .cover-image {
      height: 108px;
    }
  }
  @media (min-width: 1024px) {
    width: 400px;
    .cover-image {
      height: 200px;
    }
  }
  .medium-content {
    ${(props) => props.theme.typography.paragraph4}
    color: ${(props) => props.theme.textDisabled};
    height: 48px;
    overflow: hidden;
    margin-top: 8px;
    @media (max-width: 460px) {
      display: none;
    }
  }
  .read-more {
    ${(props) => props.theme.typography.typographyMap}
    color: ${(props) => props.theme.textDisabled};
    @media (max-width: 460px) {
      display: none;
    }
    @media (max-width: 1420px) {
      font-size: 12px;
    }
  }
`
const ArticleDetails = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 2px;
  .article-username {
    ${(props) => props.theme.typography.typographyMap}
    display: flex;
    align-items: center;
    text-align: center;
    color: ${(props) => props.theme.whiteAlpha60};
    @media (max-width: 1420px) {
      font-size: 14px;
    }
  }
  .article-date {
    ${(props) => props.theme.typography.typographyMap1}
    display: flex;
    align-items: center;
    text-align: center;
    color: ${(props) => props.theme.whiteAlpha60};
    @media (max-width: 1420px) {
      font-size: 12px;
    }
  }
`
const ArticleTitle = styled.div`
  height: 48px;
  margin-top: 20px;
  ${(props) => props.theme.typography.heroHeadline2}
  display: flex;
  align-items: start;
  font-weight: 600;
  line-height: 150%;
  font-size: 1rem;
  color: ${(props) => props.theme.sneakPeakTitleColor};
  @media (max-width: 1420px) {
    font-size: 1rem;
  }
`
const ArticleCardComponent: React.FC<ArticleProps> = ({
  articlephoto,
  articletitle,
  readingtime,
  previewtext,
  username,
  releasedate,
}) => {
  return (
    <ArticleCardStyle>
      <img
        src={articlephoto}
        width={"100%"}
        height={"200px"}
        className={"cover-image"}
      />
      <ArticleTitle>{articletitle}</ArticleTitle>
      <ReadTime>
        <img src={"assets/imgs/round-time.svg"} />
        <div className={"readtime-text"}>{readingtime}</div>
      </ReadTime>
      <div className={"medium-content"}>{previewtext}</div>
      <div className={"read-more"}>{"Read more"}</div>
      <ArticleUserDetails>
        <img src={"/assets/imgs/user.png"} width={"40px"} height={"40px"} />
        <ArticleDetails>
          <div className={"article-username"}>{username}</div>
          <div className={"article-date"}>{releasedate}</div>
        </ArticleDetails>
      </ArticleUserDetails>
    </ArticleCardStyle>
  )
}

export { ArticleCardComponent }
